<template>
    <div>
        <v-card flat>
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong>
                        Print Misc Fee Receipt
                    </strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-btn v-if="learner_misc_data != null" class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
            <span v-if="learner_misc_data != null">
                <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                    <v-radio label="Both" value="both" color="#0f2027"></v-radio>
                    <v-radio label="Office Copy" value="office" color="#0f2027"></v-radio>
                    <v-radio label="Student Copy" value="student" color="#0f2027"></v-radio>
                </v-radio-group>
                <!-- {{org_basic_data}} -->
                <v-row dense>
                    <v-col cols="12" sm="6" md="6" v-if="radios == 'office'" class="print-receipt-col single-receipt">
                        <v-card>
                            <v-simple-table dense class="elevation-1 table-container">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th colspan="3">
                                                <center><strong>Misc Fee Receipt</strong></center>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th v-if="org_basic_data.trust_logo">
                                                <center><img :src="org_basic_data.trust_logo" class="print-logo" width="50%" alt="logo" /></center>
                                            </th>
                                            <td>
                                                <center>
                                                    <tr v-if="org_basic_data.trust_name">
                                                        <strong>{{org_basic_data.trust_name}}</strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.school_name">
                                                        <strong>{{org_basic_data.school_name}} </strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.address">
                                                        {{org_basic_data.address}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.phone">
                                                        Phone : {{org_basic_data.phone}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.email">
                                                        Email : {{org_basic_data.email}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.website">
                                                        Website : {{org_basic_data.website}}
                                                    </tr>
                                                </center>
                                            </td>
                                            <th v-if="org_basic_data.school_logo">
                                                <center><img :src="org_basic_data.school_logo" class="print-logo" width="50%" alt="logo" /></center>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <center><strong>Student Details</strong></center>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">PRN No. : {{learner_misc_data.registration_number}}</td>
                                            <td colspan="">Standard : {{learner_misc_data.standard}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">Student Name : {{learner_misc_data.name}}</td>
                                            <td colspan="">Date : {{learner_misc_data.receipt_date}}</td>
                                        </tr>
                                        <!--<tr>
                                            <td colspan="3">Standard : {{learner_misc_data.standard}}</td>
                                        </tr> -->
                                        <tr>
                                            <td colspan="3">Receipt No. : {{learner_misc_data.receipt_no}} (Office Copy)</td>
                                        </tr>
                                       <!-- <tr>
                                            <td colspan="3">Date : {{learner_misc_data.receipt_date}}</td>
                                        </tr> -->
                                        <tr>
                                            <td colspan="2"><strong>Misc Fee Name</strong></td>
                                            <td><strong> Fee Amount (Rs.)</strong></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colspan="2">
                                                {{learner_misc_data.miscfeesmaster}}
                                            </td>
                                            <td>{{learner_misc_data.amount}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Total Amount :</strong> Rs. {{learner_misc_data.amount}}.00</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Amount In Words :</strong> {{learner_misc_data.amount_in_words}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Mode:</strong> {{ learner_misc_data.payment_mode }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Details:</strong> {{ learner_misc_data.remark }}</td>
                                        </tr>
                                        <tr>
                                          <td colspan="3" class="text-right">
                                            <v-col cols="12" sm="12" md="12">
                                            </v-col>
                                            </td>
                                         </tr>
                                        <tr>
                                        <td colspan="3" class="text-right">
                                            <strong>Authorized Signature</strong>
                                        </td>
                                         </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" v-if="radios == 'student'" class="print-receipt-col single-receipt" >
                        <v-card>
                            <v-simple-table dense class="elevation-1 table-container">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th colspan="3">
                                                <center><strong>Misc Fee Receipt</strong></center>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th v-if="org_basic_data.trust_logo">
                                                <center><img :src="org_basic_data.trust_logo" class="print-logo" width="50%" alt="logo" /></center>
                                            </th>
                                            <td>
                                                <center>
                                                    <tr v-if="org_basic_data.trust_name">
                                                        <strong>{{org_basic_data.trust_name}}</strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.school_name">
                                                        <strong>{{org_basic_data.school_name}} </strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.address">
                                                        {{org_basic_data.address}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.phone">
                                                        Phone : {{org_basic_data.phone}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.email">
                                                        Email : {{org_basic_data.email}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.website">
                                                        Website : {{org_basic_data.website}}
                                                    </tr>
                                                </center>
                                            </td>
                                            <th v-if="org_basic_data.school_logo">
                                                <center><img :src="org_basic_data.school_logo" class="print-logo" width="50%" alt="logo" /></center>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <center><strong>Student Details</strong></center>
                                            </td>
                                        </tr>
                                       <tr>
                                            <td colspan="2">PRN No. : {{learner_misc_data.registration_number}}</td>
                                            <td colspan="">Standard : {{learner_misc_data.standard}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">Student Name : {{learner_misc_data.name}}</td>
                                            <td colspan="">Date : {{learner_misc_data.receipt_date}}</td>
                                        </tr>
                                        <!--<tr>
                                            <td colspan="3">Standard : {{learner_misc_data.standard}}</td>
                                        </tr> -->
                                        <tr>
                                            <td colspan="3">Receipt No. : {{learner_misc_data.receipt_no}} (Student Copy)</td>
                                        </tr>
                                       <!-- <tr>
                                            <td colspan="3">Date : {{learner_misc_data.receipt_date}}</td>
                                        </tr> -->
                                        <tr>
                                            <td colspan="2"><strong>Misc Fee Name</strong></td>
                                            <td><strong> Fee Amount (Rs.)</strong></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colspan="2">
                                                {{learner_misc_data.miscfeesmaster}}
                                            </td>
                                            <td>{{learner_misc_data.amount}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Total Amount :</strong> Rs. {{learner_misc_data.amount}}.00</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Amount In Words :</strong>  {{learner_misc_data.amount_in_words}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Mode:</strong> {{ learner_misc_data.payment_mode }}</td>
                                        </tr>
                                         <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Details:</strong> {{ learner_misc_data.remark }}</td>
                                        </tr>
                                        <tr>
                                          <td colspan="3" class="text-right">
                                            <v-col cols="12" sm="12" md="12">
                                            </v-col>
                                            </td>
                                         </tr>
                                        <tr>
                                        <td colspan="3" class="text-right">
                                            <strong>Authorized Signature</strong>
                                        </td>
                                         </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row dense v-if="radios == 'both'" class="print-both-wrapper">
                    <v-col cols="12" sm="6" md="6" class="print-receipt-col">
                        <v-card>
                            <v-simple-table dense class="print-table">
                                <template v-slot:default>
                                    <thead>
                                      <tr>
                                            <th colspan="3">
                                                <center><strong>Misc Fee Receipt</strong></center>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th v-if="org_basic_data.trust_logo">
                                                <center><img :src="org_basic_data.trust_logo" class="print-logo" width="50%" alt="logo" /></center>
                                            </th>
                                            <td>
                                                <center>
                                                    <tr v-if="org_basic_data.trust_name">
                                                        <strong>{{org_basic_data.trust_name}}</strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.school_name">
                                                        <strong>{{org_basic_data.school_name}} </strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.address">
                                                        {{org_basic_data.address}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.phone">
                                                        Phone : {{org_basic_data.phone}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.email">
                                                        Email : {{org_basic_data.email}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.website">
                                                        Website : {{org_basic_data.website}}
                                                    </tr>
                                                </center>
                                            </td>
                                            <th v-if="org_basic_data.school_logo">
                                                <center><img :src="org_basic_data.school_logo" class="print-logo" width="50%" alt="logo" /></center>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <center><strong>Student Details</strong></center>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">PRN No. : {{learner_misc_data.registration_number}}</td>
                                            <td colspan="">Standard : {{learner_misc_data.standard}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">Student Name : {{learner_misc_data.name}}</td>
                                            <td colspan="">Date : {{learner_misc_data.receipt_date}}</td>
                                        </tr>
                                        <!--<tr>
                                            <td colspan="3">Standard : {{learner_misc_data.standard}}</td>
                                        </tr> -->
                                        <tr>
                                            <td colspan="3">Receipt No. : {{learner_misc_data.receipt_no}} (Office Copy)</td>
                                        </tr>
                                       <!-- <tr>
                                            <td colspan="3">Date : {{learner_misc_data.receipt_date}}</td>
                                        </tr> -->
                                        <tr>
                                            <td colspan="2"><strong>Misc Fee Name</strong></td>
                                            <td><strong> Fee Amount (Rs.)</strong></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colspan="2">
                                                {{learner_misc_data.miscfeesmaster}}
                                            </td>
                                            <td>{{learner_misc_data.amount}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Total Amount :</strong> Rs. {{learner_misc_data.amount}}.00</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Amount In Words :</strong>  {{learner_misc_data.amount_in_words}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Mode:</strong> {{ learner_misc_data.payment_mode }}</td>
                                        </tr>
                                         <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Details:</strong> {{ learner_misc_data.remark }}</td>
                                        </tr>
                                        <tr>
                                          <td colspan="3" class="text-right">
                                            <v-col cols="12" sm="12" md="12">
                                            </v-col>
                                            </td>
                                         </tr>
                                        <tr>
                                        <td colspan="3" class="text-right">
                                            <strong>Authorized Signature</strong>
                                        </td>
                                         </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="print-receipt-col">
                        <v-card>
                            <v-simple-table dense class="print-table">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th colspan="3">
                                                <center><strong>Misc Fee Receipt</strong></center>
                                            </th>
                                        </tr>
                                        <tr>
                                           <th v-if="org_basic_data.trust_logo">
                                                <center><img :src="org_basic_data.trust_logo" class="print-logo" width="50%" alt="logo" /></center>
                                            </th>
                                            <td>
                                                <center>
                                                    <tr v-if="org_basic_data.trust_name">
                                                        <strong>{{org_basic_data.trust_name}}</strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.school_name">
                                                        <strong>{{org_basic_data.school_name}} </strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.address">
                                                        {{org_basic_data.address}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.phone">
                                                        Phone : {{org_basic_data.phone}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.email">
                                                        Email : {{org_basic_data.email}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.website">
                                                        Website : {{org_basic_data.website}}
                                                    </tr>
                                                </center>
                                            </td>
                                            <th v-if="org_basic_data.school_logo">
                                                <center><img :src="org_basic_data.school_logo" class="print-logo" width="50%" alt="logo" /></center>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <center><strong>Student Details</strong></center>
                                            </td>
                                        </tr>
                                       <tr>
                                            <td colspan="2">PRN No. : {{learner_misc_data.registration_number}}</td>
                                            <td colspan="">Standard : {{learner_misc_data.standard}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">Student Name : {{learner_misc_data.name}}</td>
                                            <td colspan="">Date : {{learner_misc_data.receipt_date}}</td>
                                        </tr>
                                        <!--<tr>
                                            <td colspan="3">Standard : {{learner_misc_data.standard}}</td>
                                        </tr> -->
                                        <tr>
                                            <td colspan="3">Receipt No. : {{learner_misc_data.receipt_no}} (Student Copy)</td>
                                        </tr>
                                       <!-- <tr>
                                            <td colspan="3">Date : {{learner_misc_data.receipt_date}}</td>
                                        </tr> -->
                                        <tr>
                                            <td colspan="2"><strong>Misc Fee Name</strong></td>
                                            <td><strong> Fee Amount (Rs.)</strong></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colspan="2">
                                                {{learner_misc_data.miscfeesmaster}}
                                            </td>
                                            <td>{{learner_misc_data.amount}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Total Amount :</strong> Rs. {{learner_misc_data.amount}}.00</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Amount In Words :</strong> {{learner_misc_data.amount_in_words}} </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Mode:</strong> {{ learner_misc_data.payment_mode }}</td>
                                        </tr>
                                         <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Details:</strong> {{ learner_misc_data.remark }}</td>
                                        </tr>
                                        <tr>
                                          <td colspan="3" class="text-right">
                                            <v-col cols="12" sm="12" md="12">
                                            </v-col>
                                            </td>
                                         </tr>
                                        <tr>
                                        <td colspan="3" class="text-right">
                                            <strong>Authorized Signature</strong>
                                        </td>
                                         </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                </v-row>
            </span>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                overlay: false,
                learner_misc_data: null,
                radios: null,
                receipt_no: null,
                registration_no: null,
                ay: null,
                radios: null,
                org_basic_data:[],
            };
        },
        watch: {
            receipt_no() {
                this.getData();
            },

            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        created() {
            this.receipt_no = JSON.parse(this.$session.get("receipt_no"));
            this.ay = JSON.parse(this.$session.get("ay"));
            this.registration_no = JSON.parse(this.$session.get("registration_no"));
        },
        mounted() {
            this.getData();
        },
        methods: {
            // print() {
            //     this.$store.state.drawer = false;
            //     let that = this;
            //     window.onafterprint = function () {
            //         that.$store.state.drawer = true;
            //     };
            //     setTimeout(function () {
            //         window.print();
            //     }, 100);
            // },
            print() {
  this.$store.state.drawer = false;
  setTimeout(() => window.print(), 200);
  window.onafterprint = () => this.$store.state.drawer = true;
},
            convert(number) {
                var converter = require("number-to-words");
                const string = converter.toWords(number);
                const string1 = string.charAt(0).toUpperCase() + string.slice(1);
                return string1;
            },
            getData() {
                this.overlay = true;
                this.learner_misc_data = null;
                const formData = {
                    receipt_no: this.receipt_no,
                    registration_no: this.registration_no,
                    ay: this.ay,
                };
                axios
                    .post("/AccountingAndFees/getStudentMiscFeeReceipt", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_misc_data = res.data.student_misc_details;
                            this.org_basic_data = res.data.org_basic_data;
                            this.overlay = false;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.overlay = false;
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        //close loader
                        this.overlay = false;
                    });
            },
        },
    };
</script>
<style>
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }

    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    @page {
    size: A4 landscape;
    margin: 0;
}
@media print {

    

    .no-display,
    .v-btn,
    .v-toolbar,
    .v-radio-group,
    header,
    footer,
    nav,
    .v-navigation-drawer,
    .v-overlay {
        display: none !important;
    }



    @page {
        size: A4 landscape;
        margin: 0;
    }

    html,
    body,
    #app {
        width: 297mm !important;
        height: 210mm !important;

        margin: 0 !important;
        padding: 0 !important;

        overflow: hidden !important;
    }


    

    .v-application,
    .v-application--wrap,
    .v-main,
    .v-main__wrap,
    .v-content {
        width: 100% !important;

        height: auto !important;
        min-height: 0 !important;

        margin: 0 !important;
        padding: 0 !important;

        overflow: visible !important;
    }


   

    .print-both-wrapper {
        position: absolute !important;

        top: 6mm !important;
        left: 5mm !important;

        width: 287mm !important;

        display: flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap !important;

        justify-content: space-between !important;
        align-items: flex-start !important;

        gap: 5mm !important;

        margin: 0 !important;
        padding: 0 !important;

        box-sizing: border-box !important;

        page-break-before: avoid !important;
        page-break-after: avoid !important;
        page-break-inside: avoid !important;

        break-before: avoid !important;
        break-after: avoid !important;
        break-inside: avoid-page !important;
    }


    

    .print-both-wrapper > .print-receipt-col {

        flex: 0 0 138mm !important;

        width: 138mm !important;
        max-width: 138mm !important;
        min-width: 138mm !important;

        margin: 0 !important;
        padding: 0 !important;

        box-sizing: border-box !important;
    }


    .print-both-wrapper .v-card {

        width: 138mm !important;

        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;

        margin: 0 !important;
        padding: 0 !important;

        box-shadow: none !important;

        box-sizing: border-box !important;
    }


    .print-both-wrapper .v-simple-table,
    .print-both-wrapper .print-table,
    .print-both-wrapper table {

        width: 138mm !important;
        max-width: 138mm !important;

        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;

        margin: 0 !important;
        padding: 0 !important;

        border-collapse: collapse !important;
        table-layout: fixed !important;

        box-sizing: border-box !important;

        page-break-inside: avoid !important;
        break-inside: avoid-page !important;
    }


    .print-both-wrapper th,
    .print-both-wrapper td {

        border: 1px solid #000 !important;

        padding: 5px 7px !important;

        font-size: 11px !important;

        line-height: 1.3 !important;

        vertical-align: middle !important;

        box-sizing: border-box !important;
    }


    .print-both-wrapper thead tr:first-child th {

        font-size: 13px !important;

        font-weight: 700 !important;

        padding: 5px !important;

        line-height: 1.3 !important;

        text-align: center !important;
    }


    .print-both-wrapper .print-logo {

        display: block !important;

        width: 100px !important;
        max-width: 100px !important;

        height: auto !important;

        margin: 4px auto !important;
    }


    

    .single-receipt {

        position: absolute !important;

        top: 8mm !important;
        left: 50% !important;

        transform: translateX(-50%) !important;

        width: 240mm !important;
        min-width: 240mm !important;
        max-width: 240mm !important;

       
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;

        margin: 0 !important;
        padding: 0 !important;

        box-sizing: border-box !important;

        page-break-before: avoid !important;
        page-break-after: avoid !important;
        page-break-inside: avoid !important;

        break-before: avoid !important;
        break-after: avoid !important;
        break-inside: avoid-page !important;
    }


   

    .single-receipt > .v-card,
    .single-receipt .v-card {

        width: 240mm !important;
        max-width: 240mm !important;

        /*
         * Natural height.
         */
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;

        margin: 0 !important;
        padding: 0 !important;

        box-shadow: none !important;

        box-sizing: border-box !important;

        page-break-before: avoid !important;
        page-break-after: avoid !important;
        page-break-inside: avoid !important;

        break-before: avoid !important;
        break-after: avoid !important;
        break-inside: avoid-page !important;
    }


   
    .single-receipt .v-simple-table,
    .single-receipt .print-table,
    .single-receipt table {

        width: 240mm !important;
        max-width: 240mm !important;

        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;

        margin: 0 !important;
        padding: 0 !important;

        border-collapse: collapse !important;

        table-layout: fixed !important;

        box-sizing: border-box !important;

        page-break-before: avoid !important;
        page-break-after: avoid !important;
        page-break-inside: avoid !important;

        break-before: avoid !important;
        break-after: avoid !important;
        break-inside: avoid-page !important;
    }



    .single-receipt th,
    .single-receipt td {

        border: 1px solid #000 !important;

        padding: 9px 12px !important;

        font-size: 15px !important;

        line-height: 1.45 !important;

        vertical-align: middle !important;

        box-sizing: border-box !important;

        page-break-inside: avoid !important;
        break-inside: avoid !important;
    }



    .single-receipt thead tr:first-child th {

        font-size: 18px !important;

        font-weight: 700 !important;

        padding: 9px !important;

        line-height: 1.3 !important;

        text-align: center !important;
    }


   

    .single-receipt td strong {

        font-size: 15px !important;

        line-height: 1.4 !important;
    }


    .single-receipt td {

        font-size: 15px !important;

        line-height: 1.45 !important;
    }


    

    .single-receipt .print-logo {

        display: block !important;

        width: 100px !important;
        max-width: 100px !important;

        height: auto !important;

        margin: 6px auto !important;
    }


    .single-receipt .text-right {

        font-size: 15px !important;

        font-weight: 700 !important;

        padding-top: 12px !important;
        padding-bottom: 12px !important;
    }


    .single-receipt,
    .single-receipt *,
    .print-receipt-col,
    .print-receipt-col *,
    .print-both-wrapper,
    .print-both-wrapper * {

        page-break-before: avoid !important;
        page-break-after: avoid !important;
        page-break-inside: avoid !important;

        break-before: avoid !important;
        break-after: avoid !important;
        break-inside: avoid-page !important;
    }
}

    .table-container {
        overflow-x: hidden;
        overflow: hidden;
    }
</style>
